<nz-date-picker nzFormat="mediumDate" [nzDisabledDate]="disabledDate" [nzMode]="'date'" [nzBorderless]="true"
    [(ngModel)]="question.answer" (ngModelChange)="validateAnswer()" [nzAllowClear]="false">
</nz-date-picker>